import styles from './styles.module.scss'

interface CheckboxGroupProps {
  children: React.ReactNode
  className?: string
}

const CheckboxGroup = ({ children, className }: CheckboxGroupProps) => {
  return <div className={`${styles.checkboxGroup} ${className || ''}`}>{children}</div>
}

export default CheckboxGroup
